// extracted by mini-css-extract-plugin
export default {"assessmentBy":"AssessmentBy_assessmentBy__nBvTu","title":"AssessmentBy_title__grf67","text":"AssessmentBy_text__WOlCZ"};